module.exports = __webpack_public_path__ + "img/SRM.f1052c76.svg";